<script>
import {onMount} from 'svelte';
import {Card, Button} from './ui';
import {Image} from './display';

import CompetitorEdit from '../edit/Competitor_Edit.svelte';

import Icon from 'svelte-awesome';
import {faPen, faCheck} from '@fortawesome/free-solid-svg-icons';

export let model;
export let editMode;

onMount(()=>{
   editMode = model.url == null;
})

function editMessage(event) {
    model.screenshot = event.detail.url;
    model.text = event.detail.text;
    editMode = false;
}
</script>


<Card class="relative">
    {#if editMode}
        <CompetitorEdit bind:url={model.url} on:message={editMessage} class="p-4" />
    {:else}
    <div>
        {#if model.screenshot != null}
        <Image bind:src={model.screenshot} class="h-auto w-full" isExternal={true} />
        {/if}
        <div class="p-4">
             <p>Website: {model.url}</p>
            {#if model.extractions}
            <p class="text-xl">Logos</p>
            <div class="bg-cool-gray-400">
                {#each model.extractions.logo as logo}
                    <Image class="mt-2 ml-4 h-16 w-auto" bind:src={logo} isExternal={true} />
                {/each}
            </div>
            <p class="mt-2 text-xl">Site Styles</p>
            {#each model.extractions["site-style"] as siteStyle}
                 <p class="mt-2 text-xl">Colors</p>
                {#each siteStyle.colors as col}
                    <p class="mt-2">{col}: <span class="inline-block w-4 h-4" style="background:{col};border: solid 1px black"></span></p>
                {/each}
                  <p class="mt-2 text-xl">Grays</p>
                {#each siteStyle.grays as gray}
                    <p class="mt-2">{gray}: <span class="inline-block w-4 h-4" style="background:{gray}; border: solid 1px black"></span></p>
                {/each}
            {/each}
            {/if}

            {#if model.text}
            {#each model.text as text}
                <p class:text-4xl={text.tagName == 'H1'} 
                class:text-3xl={text.tagName == 'H2'} 
                class:text-2xl={text.tagName == 'H3'} 
                class:text-xl={text.tagName == 'H4'}>
                    <b>{text.tagName}: </b>{text.textContent}
                </p>
            {/each}
            {/if}
        </div>
   
    </div>
    {/if}
     {#if !editMode}
        <Button on:submit={()=>{editMode = !editMode}} class="m-4" primary={true}>EDIT</Button>
        {:else}
          <Button on:submit={()=>{editMode = !editMode}} class="m-4">Cancel</Button>
       {/if}

</Card>